import request from "@/utils/request";

/**
 * 注册账号
 * @param {Object} paramObj
 * @method post
 */
export function registerAccount(paramObj) {
    return request({
        url: "/api/system/LoginController/register",
        method: "post",
        data: paramObj
    });
}

/**
 * 获取手机验证码
 * @param {Object} paramObj
 * @method post
 */
export function phoneCode(paramObj) {
  return request({
      url: "/api/system/verification/verificationCode",
      method: "post",
      params: paramObj
  });
}

export function phoneCodeNew(paramObj,data) {
    return request({
        url: "/api/system/verification/verificationCodeNew",
        method: "post",
        params: paramObj,
        data:data
    });
}


/**
 * 账号密码登录
 * @param {Object} paramObj
 * @method post
 */
export function login(paramObj) {
  return request({
      url: "/api/system/LoginController/login",
      method: "post",
      data: paramObj
  });
}

/**
 * 手机验证码登录
 * @param {Object} paramObj
 * @method post
 */
export function loginPhone(paramObj) {
  return request({
      url: "/api/system/LoginController/loginPhone",
      method: "post",
      data: paramObj
  });
}


/**
 * 获取用户详细信息
 * @param {Object} paramObj
 * @method get
 */
export function getInfo() {
  return request({
    url: '/api/system/user/getInfo',
    method: 'get'
  })
}


/**
 * 退出
 * @param {Object} paramObj
 * @method delete
 */
export function logout() {
  return request({
    url: '/api/system/LoginController/logout',
    method: 'delete'
  })
}

/**
 * 修改密码
 * @param {Object} paramObj
 * @method post
 */
export function checkVerifyCode (params) {
  return request({
    url: '/api/system/verification/verifyCode',
    headers: {
      isToken: false
    },
    method: 'post',
    data: params
  })
}

/**
 * 修改密码
 * @param {Object} paramObj
 * @method post
 */
export function updatePass (data) {
  return request({
    url: '/api/system/LoginController/updatePasswordNovcerificationCode',
    headers: {
      isToken: false
    },
    method: 'post',
    data
  })
}

// 刷新方法
export function refreshToken() {
  return request({
    url: '/api/system/LoginController/refreshReturnToken',
    method: 'post'
  })
}

// 获取注册时法人手机号
export function getUserName (data) {
  return request({
    url: '/api/system/LoginController/getUserName',
    method: 'post',
    data
  })
}

//统一认证登陆
export function redirectLogin(params) {
  return request({
    url: '/api/system/LoginController/ThirdLogin',
    headers: {
      isToken: false
    },
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/interfaceAPI/login/interfaceAPI.js